// VS Bot Luck Report capture: records the engine's own emitted events and
// the two formation deals so the server's existing card-luck collector can
// build the report. Observer only — never touches gameplay, RNG or Bot AI.
const PREFIX = 'kickard.practiceTrace.';
const KEEP = 3;

const pick = (p) => ({ goalkeeper: p.goalkeeper, defenses: p.defenses, attacks: p.attacks });
const formation = (s) => JSON.parse(JSON.stringify({ p1: pick(s.players.p1), p2: pick(s.players.p2) }));

export function startPracticeTrace(state) {
  return {
    engineMatchId: state.matchId,
    p1Name: state.players.p1.name || null,
    p2Name: state.players.p2.name || null,
    initialPlayers: formation(state),
    steps: [],
    sawHalf2: false,
    saved: false,
  };
}

export function recordPracticeStep(trace, state, events) {
  if (!trace || trace.saved || !events || events.length === 0) return;
  const step = {
    half: state.half,
    phase: state.phase,
    suddenDeath: !!state.penalty?.suddenDeath,
    events: JSON.parse(JSON.stringify(events)),
  };
  if (state.half === 2 && !trace.sawHalf2) {
    step.players = formation(state);
    trace.sawHalf2 = true;
  }
  trace.steps.push(step);
}

export function savePracticeTrace(trace, state) {
  if (!trace || trace.saved || !state.endState) return;
  trace.saved = true;
  const { sawHalf2, saved, ...rest } = trace;
  const payload = {
    ...rest,
    endState: state.endState,
    finalHalf: state.half,
    penaltyShots: state.penalty?.shots?.length || 0,
    p1Score: state.players.p1.score,
    p2Score: state.players.p2.score,
    completedAt: new Date().toISOString(),
  };
  try {
    const old = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(PREFIX)) {
        let at = '';
        try { at = JSON.parse(sessionStorage.getItem(k))?.completedAt || ''; } catch (_) { /* corrupt */ }
        old.push([at, k]);
      }
    }
    old.sort((a, b) => (a[0] < b[0] ? -1 : 1));
    old.slice(0, Math.max(0, old.length - (KEEP - 1))).forEach(([, k]) => sessionStorage.removeItem(k));
    sessionStorage.setItem(PREFIX + trace.engineMatchId, JSON.stringify(payload));
  } catch (_) { /* quota / private mode → no bot report */ }
}

export function loadPracticeTrace(matchId) {
  try {
    const raw = matchId ? sessionStorage.getItem(PREFIX + matchId) : null;
    return raw ? JSON.parse(raw) : null;
  } catch (_) { return null; }
}

export function hasPracticeTrace(matchId) {
  try { return !!matchId && !!sessionStorage.getItem(PREFIX + matchId); } catch (_) { return false; }
}
